<template>
  <StatusBadge
    :status="mfaStatus.status"
    :text="mfaStatus.text"
  />
</template>

<script>
import {
  StatusBadge,
} from '@jumpcloud/ui-components';

// TODO: Use badgeStatus constants when they are exported in PRO-645
// const { badgeStatus } = Constants;

export default {
  name: 'StatusBadgeMFA',

  components: {
    StatusBadge,
  },

  props: {
    enableMultiFactor: Boolean,
    totpEnrolled: Boolean,
  },

  computed: {
    mfaStatus() {
      const { enableMultiFactor, totpEnrolled } = this;
      const label = 'mfa';
      const labelStatus = totpEnrolled ? 'enrolled' : 'not required';

      return {
        status: enableMultiFactor ? 'success' : 'inactive',
        text: enableMultiFactor ? `${label} required` : `${label} ${labelStatus}`,
      };
    },
  },
};
</script>
